import React, { useState, useRef, useEffect } from 'react';
import { compose } from '@/utils/story-composer';
import SliderItem from '@/components/vertical-slider/slider-item';
import { useIntersection } from '@/hooks/use-intersection';
import SliderContent from '@/components/vertical-slider/slider-content';

function VerticalSlider({ elementProps, sliderItems }) {
	const [activeSliderIndex, setActiveSliderIndex] = useState(0);
	const [autoplay, setAutoplay] = useState(null);

	const desktopSlider = useRef();
	const verticalSlider = useRef();
	const rootMargin = '-100px';
	const inViewport = useIntersection(verticalSlider, rootMargin);
	const desktopSliderVisible = useIntersection(desktopSlider, rootMargin);

	const itemClicked = index => {
		setActiveSliderIndex(index);
		setAutoplay(false);
	};

	useEffect(() => {
		if (inViewport) {
			setAutoplay(true);
		} else {
			setAutoplay(null);
		}
	}, [inViewport]);

	return (
		<div {...elementProps} className="grid grid-cols-6 col-span-6 gap-10" ref={verticalSlider}>
			<div className="col-span-6 lg:col-span-2 xl:col-span-3">
				{sliderItems &&
					sliderItems.map((item, index) => {
						const isActiveItem = index === activeSliderIndex;
						return (
							<div key={item._uid}>
								<SliderItem
									{...item}
									isActiveItem={isActiveItem}
									autoplay={autoplay}
									itemClicked={() => itemClicked(index)}
									nextItem={() => setActiveSliderIndex((activeSliderIndex + 1) % sliderItems.length)}
								/>
								{/* Only render when desktop slider is NOT visible and the vertical-slider component is in the viewport */}
								{inViewport && !desktopSliderVisible ? <SliderContent {...item} isActiveItem={isActiveItem} /> : null}
							</div>
						);
					})}
			</div>

			<div className="col-span-4 lg:col-span-4 xl:col-span-3 hidden lg:block" ref={desktopSlider}>
				{sliderItems &&
					sliderItems.map((item, index) => {
						const isActiveItem = index === activeSliderIndex;
						return (
							<div key={item._uid}>
								{/* Only render when desktop slider and the vertical-slider component is in the viewport */}
								{inViewport && desktopSliderVisible ? <SliderContent {...item} isActiveItem={isActiveItem} /> : null}
							</div>
						);
					})}
			</div>
		</div>
	);
}

export default VerticalSlider;

compose('vertical-slider', VerticalSlider);
